import { CountDistinctQualifier, CriteriaType, CriterionNode, FilterQualifier, QualifierType } from '../../../state'

// TODO: is there a better place for this function?
export function findQualifierByType<T>(qualifiers: FilterQualifier[], type: QualifierType): T | undefined {
    const countDistinctQualifier = qualifiers.find((q) => q.type === QualifierType.CountDistinctQualifierDTO)
    if (countDistinctQualifier) {
        if (Array.isArray((countDistinctQualifier as CountDistinctQualifier).qualifiers)) {
            return findQualifierByType<T>((countDistinctQualifier as CountDistinctQualifier).qualifiers!, type)
        }
    }

    return qualifiers.find((q) => q.type === type) as T
}

export function countFilterValuesByField(node: CriterionNode, field: string): number {
    if (node?.filters[0]?.field === field) {
        return node.filters[0].values.length
    }

    return 0
}

export function getFilterValuesByField(node: CriterionNode, field: string): string[] {
    return node.filters.find((f) => f.field === field)?.values ?? []
}

export function isGemMappedIcd10Qualifier(node: CriterionNode): boolean {
    return node?.type === CriteriaType.Diagnosis && node?.filters[0]?.field !== 'boc_cui' && !node.filters[0]?.field.endsWith('_icd10')
}

export function isIcd10Qualifier(node: CriterionNode): boolean {
    return node?.type === CriteriaType.Diagnosis && node?.filters[0]?.field.endsWith('_icd10')
}

export function isCuiQualifier(node: CriterionNode): boolean {
    return node?.type === CriteriaType.Diagnosis && node?.filters[0]?.field === 'boc_cui'
}
